import { UploadOSS } from '@da-vinci/utils'
import { getOssAccessKey } from '@/api'

const ossClient = new UploadOSS()
ossClient.setOptions({
  getOssAccessKey,
  fakeProgress: true,
})

const filesCatch = new Map<string, Promise<string>>()
export function uploadFile(
  file: File,
  opt?: {
    processFn?: (progress: string | number) => void
    md5?: string
  }
) {
  if (opt?.md5 && filesCatch.has(opt.md5)) {
    return filesCatch.get(opt.md5)!
  }
  const res = ossClient.uploadFile(file, opt?.processFn)
  if (opt?.md5) {
    filesCatch.set(opt.md5, res)
  }
  return res
}
